export default class Counter
{
    protected items: Array<any>;
    protected nodes: NodeListOf<Element>;

    /**
     * @param {string|NodeListOf<Element>} nodes - селектор или корневой элемент блока верстки
     * @param {Array}          items - массив элементов для подсчета
     */
    public constructor(nodes: string|NodeListOf<Element>, items: Array<any> = [])

    {
        this.items = items;
        this.nodes = typeof nodes === 'string' ? document.querySelectorAll(nodes) : nodes;

        this.nodes.forEach(node => {
            let counter = this.createCounterNode();

            node.appendChild(counter);
        });

        this.updateState();
    }

    public add(itemId: number)
    {
        if (this.items.indexOf(itemId) === -1) {
            this.items.push(itemId);

            this.updateState();
        }
    }

    public remove(itemId: number)
    {
        let idx = this.items.indexOf(itemId);

        if (idx !== -1) {
            this.items.splice(idx, 1);
            
            this.updateState();
        }
    }

    public count(): number
    {
        return this.items.length;
    }

    protected createCounterNode(): Element
    {
        let counter = document.createElement('div');
        counter.classList.add('counter__value');

        return counter;
    }

    protected updateCounter(counter: Element): Element
    {
        counter.innerHTML = this.count().toString();

        return counter;
    }

    protected updateState()
    {
        this.nodes.forEach(node => {
            let counter = node.querySelector('.counter__value');

            if (counter) {
                this.updateCounter(counter);
            }

            if (this.count() > 0) {
                counter.classList.add('counter__value_visible');
            } else {
                counter.classList.remove('counter__value_visible');
            }
        });
    }
}
